
import { defineComponent, computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { ClientService } from '../client.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
export default defineComponent({
  name: 'ClientBlackListModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array as PropType<Array<{
          device_id: string,
          computer_name: string
        }>>,
      default: () => [{
        device_id: '',
        computer_name: ''
      }]
    }
  },
  emits: ['closeClientModal', 'reloadData'],
  setup (props, context) {
    const { t } = useI18n()
    const injector = useReflectiveInjector([ClientService])
    const clientService = injector.get(ClientService)
    const modalVisiable = computed(() => props.show)
    const blackList = computed(() => props.list)
    return {
      modalVisiable,
      blackList,
      closeModal () {
        context.emit('closeClientModal', 'MODAL_CLIENT_BLACKLIST')
      },
      cancelBlackList (id: string) {
        clientService.cancelBlackList({ device_id: id }).then(() => {
          ElMessage.success(t('groupClient.blacklistRemoveSuccess'))
          context.emit('reloadData', 'CANCEL_BLACK_LIST')
        }).catch(() => {
          ElMessage.error(t('groupClient.blacklistRemoveFail'))
        })
        context.emit('closeClientModal', 'MODAL_CLIENT_BLACKLIST')
      }
    }
  }
})
